import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../../public/img/LLLogo.svg';
const _hoisted_1 = {
  width: "84",
  height: "85",
  viewBox: "0 0 84 85",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [_createElementVNode("image", {
    href: _imports_0,
    width: "84",
    height: "85"
  }, null, -1)]))]);
}